import { RelocationOrderStatus } from "@/api-schema-enums";

export enum StatusCategory {
  Active = "active",
  Pending = "pending",
  Arriving = "arriving",
  Issue = "issue",
}

export const STATUS_CATEGORIES: Record<string, StatusCategory> = {
  [RelocationOrderStatus.TransportCompanyInTransit]: StatusCategory.Active,
  [RelocationOrderStatus.TransportCompanyRestAtLayover]: StatusCategory.Active,
  [RelocationOrderStatus.BranchAwaitingPickup]: StatusCategory.Pending,
  [RelocationOrderStatus.TransportCompanyAwaitingReadyForTransport]: StatusCategory.Pending,
  [RelocationOrderStatus.TransportCompanyAwaitingPickupDate]: StatusCategory.Pending,
  [RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance]: StatusCategory.Arriving,
};

export const IN_TRANSIT_STATUSES = new Set([
  RelocationOrderStatus.TransportCompanyInTransit,
  RelocationOrderStatus.TransportCompanyRestAtLayover,
]);

export const PENDING_STATUSES = new Set([
  RelocationOrderStatus.BranchAwaitingPickup,
  RelocationOrderStatus.TransportCompanyAwaitingReadyForTransport,
  RelocationOrderStatus.TransportCompanyAwaitingPickupDate,
]);

export const ARRIVING_STATUSES = new Set([RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance]);

export const ISSUE_STATUSES = new Set([
  RelocationOrderStatus.TransportCompanyRejectedDamagedVehicle,
  RelocationOrderStatus.TransportCompanyRejectedMissingKeys,
  RelocationOrderStatus.TransportCompanyRejectedMissingVehicle,
  RelocationOrderStatus.BranchRejectedDamagedVehicle,
  RelocationOrderStatus.BranchRejectedMissingKeys,
  RelocationOrderStatus.BranchRejectedMissingVehicle,
  RelocationOrderStatus.BranchRejectedWrongVehicle,
]);

export const ACTIVE_STATUSES_LIST = [
  ...Array.from(IN_TRANSIT_STATUSES),
  ...Array.from(PENDING_STATUSES),
  ...Array.from(ARRIVING_STATUSES),
  ...Array.from(ISSUE_STATUSES),
];

export const ACTIVE_STATUSES_SET = new Set(ACTIVE_STATUSES_LIST);

export const ARC_COLORS: Record<StatusCategory, [number, number, number]> = {
  [StatusCategory.Active]: [0, 210, 255],
  [StatusCategory.Pending]: [255, 180, 50],
  [StatusCategory.Arriving]: [80, 220, 120],
  [StatusCategory.Issue]: [255, 80, 80],
};
